// src/store/index.ts
import { configureStore } from "@reduxjs/toolkit";
import extrasSlice from './state/extrasSlice';

export const store = configureStore({
  reducer: {
    extras: extrasSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
